import { array, object } from "yup";

export const sendToSlackSchema = object({
  members: array().min(1, "Please select at least one member"),
});
